export default "/_next/static/images/edge-texture-a364a1f85ca4e1e224610491de2e5270.svg";